exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /dist/src/app/user/work-record/company-modal/company-modal.component.scss
// module id = ../../../../../src/app/user/work-record/company-modal/company-modal.component.scss
// module chunks = main